import type React from "react";
import { type FC, type ReactNode } from "react";
import {
    useEffect,
    useRef,
    useState,
} from "react";
import FontAwesomeLight from "../../../app/Utilities/Platform/FontAwesome/FontAwesomeLight";

interface Props {
    error?: React.ReactNode;
    children: ReactNode;
    onClear?: () => void;
}

const BoxForm: FC<Props> = ({ error, children, onClear, ...props }) => {
    const errorRef = useRef<null | HTMLDivElement>(null);

    const [ showError, setShowError ] = useState(false);
    const [ errorHeight, setErrorHeight ] = useState(0);

    useEffect(() => {
        setShowError(!!error);
    }, [ error ]);

    useEffect(() => {
        if(showError && errorRef.current) {
            setErrorHeight(errorRef.current?.scrollHeight);
        } else {
            setErrorHeight(0);
        }
    }, [ showError ]);

    const onClick = () => {
        if(typeof onClear === "function") {
            onClear();
        }

        setShowError(false);
    };

    return (
        <div
            {...props}
            className="prose mx-auto relative p-8"
            style={showError ? {
                marginTop: `${errorHeight + 50}px`,
            } : {}}
        >
            {showError && (
                <div
                    ref={errorRef}
                    className="absolute bottom-full w-[96vw] -mb-3 ml-[calc(50%-48vw-2rem)]"
                >
                    <div className="flex w-fit bg-slate-50 mx-auto rounded-lg shadow-xl z-10 overflow-hidden">
                        <div className="flex justify-center items-center bg-red-light text-red p-2">
                            <FontAwesomeLight icon="exclamation-triangle" />
                        </div>
                        <div className="grow py-2 px-4 text-left min-w-[250px]">
                            {error}
                        </div>
                        <button
                            type="button"
                            onClick={onClick}
                            className={
                                "ignore-default p-1 my-2 mr-1 rounded-lg border-none text-black cursor-pointer " +
                                "bg-transparent hover:bg-neutral-300"
                            }
                        >
                            <FontAwesomeLight icon="times" />
                        </button>
                    </div>
                </div>
            )}
            <div className="relative rounded-lg shadow-xl bg-slate-50 p-8 z-10">
                {children}
            </div>
        </div>
    );
};

export default BoxForm;
